// /en/careers/$sphere — sphere page (EN). Unknown slug → 404.
import { createFileRoute, notFound } from "@tanstack/react-router";
import { SpherePage } from "@/careers/SpherePage";
import { careersHead, BASE_URL } from "@/careers/head";
import { sphereJsonLd } from "@/careers/careerPages";
import { UI, SPHERE_SLUGS, sphereDescription } from "@/careers/spheres";
import { buildSphere } from "@/careers/data";

export const Route = createFileRoute("/en/careers/$sphere")({
  loader: ({ params }) => {
    if (!SPHERE_SLUGS.includes(params.sphere)) throw notFound();
  },
  head: ({ params }) => {
    const slug = params.sphere;
    const data = buildSphere(slug, "en");
    if (!data) return {};
    const alt = {
      az: `/az/careers/${slug}`,
      ru: `/careers/${slug}`,
      en: `/en/careers/${slug}`,
    };
    const title = `${data.name} · ${UI.en.breadcrumbRoot} — Yolutap`;
    const description = sphereDescription("en", data.name, data.count, data.subtitle);
    const jsonLd = sphereJsonLd({
      sphereName: data.name,
      baseUrl: BASE_URL,
      rootPath: `/en/careers`,
      spherePath: `/en/careers/${slug}`,
      breadcrumbRoot: UI.en.breadcrumbRoot,
    });
    return careersHead({ lang: "en", canonicalPath: `/en/careers/${slug}`, altPaths: alt, title, description, jsonLd });
  },
  component: () => {
    const { sphere } = Route.useParams();
    return <SpherePage lang="en" slug={sphere} />;
  },
});
